import {onFilterItemClose, onFilterGroupToggle,onFilterToggle, onFilterResetAll,
  onFilterApply,onModalClose,onFilterDeactivate
} from './tableFilter/tableFilterEvents';
import { setActiveTable, tableAPI, toggleMobileMenu } from './tableFilter/tableFilterHelpers';
import { preloader } from './helpers/preloader';

/**
 * Filter table by various criteria. It is possible to combine filters.
 * Functionalities and appearance differ on small and large screens.
 */
window.HMSTableFilter = class HMSTableFilter {
  constructor() {
    this.isOpen = false;
    this.filters = new Map();
    this.state = {
      activeFilters: []
    };
    this.tempState = {
      activeFilters: []
    };
    this.init();
  }

  /**
   * Selects the panel's table and resets filters after a tab change.
   * @param {JQuery} $panel - Active table panel
   */
  resetForPanel($panel) {
    if (!$panel.closest('.component-table').find('.js-table-filter').length) {
      return;
    }

    $('body').off('click.tableFilter');
    if (this.isOpen) {
      toggleMobileMenu(this, false);
    }
    setActiveTable($panel.find('.js-table'));
    onFilterResetAll(this);
    tableAPI().columns.adjust();
  }

  /**
   * Add event listeners
   */
  addEvents() {
    $('.component-table').on('table:change', (event, $panel) =>
      this.resetForPanel($panel));
    $('.js-table-filter-item-close').on('click', event =>
      onFilterItemClose($(event.currentTarget).parents('.js-table-filter-item'), this));
    $('.js-table-filter-toggle').on('click', () =>
      toggleMobileMenu(this));
    $('.js-table-filter-item-toggle').on('click', event =>
      onFilterGroupToggle($(event.currentTarget).parents('.js-table-filter-item'), this));
    $('.js-table-filter-btn').on('click', event =>
      onFilterToggle(event, this));
    $('.js-table-filter-reset-all').on('click', () =>
      onFilterResetAll(this));
    $('.js-table-filter-apply').on('click', () =>
      onFilterApply(this));
    $('.js-close-filter-mobile').on('click', () =>
      onModalClose(this));
    $('body').on('click', '.js-table-filter-deactivate-filter', event =>
      onFilterDeactivate(event, this));
  }

  /**
   * Inits the Table filter.
   * Adds event listeners
   * Indexes the filters from the dom.
   */
  init() {
    this.addEvents();
    preloader($('.body'), false);
  }
};
